import { render, staticRenderFns } from "./Valor-Monetario.vue?vue&type=template&id=ce2d9dfc&scoped=true&"
import script from "./Valor-Monetario.vue?vue&type=script&lang=js&"
export * from "./Valor-Monetario.vue?vue&type=script&lang=js&"
import style0 from "./Valor-Monetario.vue?vue&type=style&index=0&id=ce2d9dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2d9dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce2d9dfc')) {
      api.createRecord('ce2d9dfc', component.options)
    } else {
      api.reload('ce2d9dfc', component.options)
    }
    module.hot.accept("./Valor-Monetario.vue?vue&type=template&id=ce2d9dfc&scoped=true&", function () {
      api.rerender('ce2d9dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/componentes/Valor-Monetario.vue"
export default component.exports